module.exports = __webpack_public_path__ + "img/alcance.f64165f1.png";